import { filter, takeUntil } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, NavigationEnd } from '@angular/router';
import { Constant } from 'src/app/constant/constant';
import { CommonService } from 'src/app/services/common.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { LeadTaskService } from 'src/app/services/lead-task.service';
import { LoaderService } from 'src/app/services/loader.service';
import { TwilloDialerComponent } from '../../phone-dialer/twillo-dialer/twillo-dialer.component';
import * as moment from 'moment';
import { TaskPopupComponent } from '../task-popup/task-popup.component';
import { SequencesService } from 'src/app/services/sequences.service';
import { ConversationPopupComponent } from 'src/app/shared/conversation-popup/conversation-popup.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-task-table',
  templateUrl: './task-table.component.html',
  styleUrls: ['./task-table.component.scss']
})
export class TaskTableComponent implements OnChanges, OnDestroy {

  url = '';
  sanitizedUrl = '';

  @Input() selectedTab = 'today';
  @Input() selectedFilter = 'all';
  @Input() searchTerm: string = '';

  @Input() sortKey: any;

  @Input() sequenceId: any = null;
  @Input() stepId: any = null;



  filteredTasks = [];

  spinner = false;

  @Input() public type: any = 1;
  @Input() public page: any = Constant.PAGE;
  @Input() public size: any = Constant.SIZE;
  groupBy: any = "a.task_id";

  @Input() leadId: any = 0;


  @Output() paginationInfo = new EventEmitter<any>();
  showEditPopup: boolean = true;
  total: any;


  dialerType: any;
  webMobileCallEnable: any;
  dialerEnable: boolean = false;
  lastDialedNumber: any;
  encryptPhone: any;
  encryptEmail: any;
  dialerShow: boolean = false;
  data: any;

  showFailureReason: boolean = false;

  constructor(private taskService: LeadTaskService,
    private snackBar: MatSnackBar,
    private commonService: CommonService,
    private leadActivityService: LeadActivityService,
    private loaderService: LoaderService,
    private dialog: MatDialog,
    private ecryptService: EcryptServiceService,
    private router: Router,
    private sequencesService: SequencesService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {


    this.loadTasksNew();

    this.showEditPopup = true;

    this.getAllCrmData();

    if (this.selectedTab == 'failed') {
      this.showFailureReason = true;
    } else {
      this.showFailureReason = false;
    }

  }


  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['selectedTab'] && !changes['selectedTab'].firstChange) ||
      (changes['selectedFilter'] && !changes['selectedFilter'].firstChange) ||
      (changes['searchTerm'] && !changes['searchTerm'].firstChange) ||
      (changes['sortKey'] && !changes['sortKey'].firstChange) ||
      (changes['page'] && !changes['page'].firstChange) ||
      (changes['size'] && !changes['size'].firstChange) ||
      (changes['sequenceId'] && !changes['sequenceId'].firstChange) ||
      (changes['stepId'] && !changes['stepId'].firstChange)
    ) {
      if (changes['sortKey']?.currentValue) {
        this.sortParam = `${this.sortKey.field},${this.sortKey.order}`;
      } else {
        this.sortParam = 'a.scheduled_date,ASC';
      }
    }

    this.selectedTab = changes['selectedTab'] ? changes['selectedTab'].currentValue : this.selectedTab;


    if (this.selectedTab == 'completed') {

    }


    if (this.selectedTab == 'failed') {
      this.showFailureReason = true;
    } else {
      this.showFailureReason = false;
    }

    this.loadTasksNew();
  }


  sortParam: any = 'a.scheduled_date' + "," + Constant.Asc;


  loadTasksNew(): void {
    this.filteredTasks = [];
    this.spinner = true;

    let additionalQuery = null;

    let search = null;

    if (this.type == 1) {

      additionalQuery = this.buildAdditionalQuery();



      if (additionalQuery.includes('a.completed_date IS NOT NULL')) {

        this.showEditPopup = false;
      } else if (additionalQuery.includes('a.skipped =1')) {
        this.showEditPopup = true;
      } else if (additionalQuery.includes('a.failed =1')) {
        this.showEditPopup = true;
      }
      else {
        this.showEditPopup = true;
      }

      search = this.buildSearchQuery(this.searchTerm);

    } else {

      additionalQuery = " a.lead_id = " + this.leadId;

      this.sortParam = "a.lead_id,desc"
    }

    if (this.type == 2) {
      this.sortParam = "a.task_id,asc"

    }


    this.taskService.searchTaskTabsNew1(search,
      this.page, this.size, this.sortParam, additionalQuery, this.groupBy).subscribe(
        res => {


          this.filteredTasks = res['content'];

          this.total = res['totalElements'];

          if (this.type == 1) {

            this.paginationInfo.emit({
              total: res['totalElements'],
              totalPages: res['totalPages']
            });

          }


          if (this.total == 0) {

            this.showEditPopup = false;


          }

          this.spinner = false;

          console.log("res", this.filteredTasks);

        },
        error => {

          this.spinner = false;

        }
      )

  }


  private buildAdditionalQuery(): string {
    let query = '';

    switch (this.selectedTab) {
      case 'today':
        query = 'DATE(a.scheduled_date) = CURRENT_DATE  AND a.completed !=1 AND (a.skipped = 0 OR a.skipped IS NULL) AND (a.failed = 0 OR a.failed IS NULL) AND a.current_task = 1';
        break;
      case 'upcoming':
        query = 'DATE(a.due_date) > NOW() AND a.current_task=1 AND (a.skipped = 0 OR a.skipped IS NULL) AND (a.failed = 0 OR a.failed IS NULL) AND a.completed_date IS NULL AND a.current_task = 1';
        break;
      case 'due':
        query = 'DATE(a.due_date) < NOW() AND a.current_task=1 AND (a.skipped = 0 OR a.skipped IS NULL) AND (a.failed = 0 OR a.failed IS NULL) AND a.completed_date IS NULL AND a.current_task = 1';
        break;
      case 'completed':
        query = 'a.completed_date IS NOT NULL AND (a.skipped = 0 OR a.skipped IS NULL) AND (a.failed = 0 OR a.failed IS NULL)';
        break;
      case 'skipped':
        query = 'a.skipped =1';
        break;
      case 'failed':
        query = 'a.failed =1';
        break;
      default:
        query = '1=1';
    }

    if (this.selectedFilter && this.selectedFilter !== 'all') {
      query += ` AND a.action_type_id IN (SELECT action_type_id FROM cs_action_types WHERE LOWER(action_code) = '${this.selectedFilter}')`;
    }

    if (this.sequenceId) {
      query += ` AND a.sequence_id = ${this.sequenceId}`;
    }


    if (this.stepId) {
      query += ` AND a.step_id = ${this.stepId}`;
    }

    return query;

  }


  private buildSearchQuery(value: string): string {
    if (!value || value.trim() === '') return null;

    const v = value.trim();

    return [
      `a.firstname:*${v}*`,
      `a.job_title:*${v}*`
    ].join(" OR ");
  }


  isFilterPanelOpen = false;
  selectedTask: any = null;

  togglePanel(task: any): void {


    if (this.type == 1) {

      this.toglePanelEdit(task);

    }





  }

  selectedTasks: any[] = [];

  toglePanelEdit(task: any): void {

    if (this.showEditPopup) {

      // For WhatsApp tasks (type 4), fetch full task data before opening popup
      if (task && task.type == 4 && task.taskId) {
        this.sequencesService.getTaskById(task.taskId).subscribe(
          (response) => {


            let enrichedTask = {
              ...task,
              ...response,
            };

            enrichedTask.sequenceName = task.sequenceName

            enrichedTask.jobTitle = task.jobTitle
            enrichedTask.company = task.company
            enrichedTask.leadDetails = task.leadDetails

            this.selectedTasks.push(enrichedTask);

            const dialogRef = this.dialog.open(TaskPopupComponent, {
              disableClose: true,
              data: { tasks: this.selectedTasks, startIndex: 0 },
              panelClass: 'task-popup-dialog'
            });

            dialogRef.afterClosed().subscribe(result => {
              console.log('Task popup closed');
              this.selectedTasks = [];
              if (result['event'] == 'add') {

                if (this.type == 1) {
                  this.refresh.emit(this.taskIdList);
                } else {
                  this.loadTasksNew();
                }

              }
            });
          },
          (error) => {
            console.error('Error fetching WhatsApp task data:', error);
            // Open popup with original task data if fetch fails
            this.selectedTasks.push(task);

            const dialogRef = this.dialog.open(TaskPopupComponent, {
              disableClose: true,
              data: { tasks: this.selectedTasks, startIndex: 0 },
              panelClass: 'task-popup-dialog'
            });

            dialogRef.afterClosed().subscribe(result => {
              console.log('Task popup closed');
              this.selectedTasks = [];
              if (result && result['event'] == 'add') {

                if (this.type == 1) {
                  this.refresh.emit(this.taskIdList);
                } else {
                  this.loadTasksNew();
                }
              }
            });
          }
        );
      } else {
        // For non-WhatsApp tasks, open popup normally
        this.selectedTasks.push(task);

        const dialogRef = this.dialog.open(TaskPopupComponent, {
          disableClose: true,
          data: { tasks: this.selectedTasks, startIndex: 0 },
          panelClass: 'task-popup-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Task popup closed');
          this.selectedTasks = [];
          if (result && result['event'] == 'add') {

            if (this.type == 1) {
              this.refresh.emit(this.taskIdList);
            } else {
              this.loadTasksNew();
            }
          }
        });
      }

    }


  }

  // navigateToWhatsAppCampaign(task: any, taskData: any = null): void {
  //   // Prepare lead data similar to common-product module
  //   const leadData = [{
  //     name: task.firstName || task.name || '',
  //     phoneNo: task.phoneNo || ''
  //   }];

  //   // Encrypt lead data
  //   let leadObject = JSON.stringify(leadData);
  //   let encryptedLeadObject = this.ecryptService.encryptionAES(leadObject);

  //   // Store in session storage
  //   sessionStorage.setItem('leadContactsData', encryptedLeadObject);

  //   // Build query params
  //   const queryParams: any = { 
  //     lead: encryptedLeadObject, 
  //     fromLeads: true,
  //     fromSequence: true,
  //     taskId: task.taskId || task.id
  //   };

  //   // If we have taskData with whatsappTemplateUid, pass it
  //   if (taskData && taskData.whatsappTemplateUid) {
  //     queryParams.whatsappTemplateUid = taskData.whatsappTemplateUid;
  //   }

  //   // Navigate to campaign template page
  //   this.router.navigate(['/createCampaignTemplate'], {
  //     queryParams: queryParams
  //   });
  // }


  closePopupNew(event) {
    if (event == true) {
      // this.togglePanel();
      this.isFilterPanelOpen = false;
      this.selectedTask = null;

      this.refresh.emit(this.taskIdList);
      // this.commonService.reloadCurrentRoute();
    }
  }

  skipSteps(task) {

    this.taskService.skipTask(task.taskId, task.sequenceId, task.stepId, task.userId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.loadTasksNew();
          this.refresh.emit(this.taskIdList);

        }
        else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => { });
  }

  removeForSequence(task) {

    console.log("task", task);

    this.taskService.deleteByLeadId(task.leadId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open("Lead Remove From Sequence Successfully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.loadTasksNew();
          this.refresh.emit(this.taskIdList);

        } else {
          this.snackBar.open("Lead Remove From Sequence Failed", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      error => {
        this.spinner = false;
      })

  }

  selection = new SelectionModel<any>(true, []);
  selectionTask: any = [];
  taskIdList: any = [];
  // Track rows that were marked completed/selected
  completedTasks: any[] = [];

  @Output() selectionChanged = new EventEmitter<any>();


  @Output() refresh = new EventEmitter<any>();



  toggleAllRows(isChecked: boolean) {
    if (isChecked) {
      // Select every row in the current view
      this.selection.clear();
      this.filteredTasks.forEach(row => this.selection.select(row));

      // Build taskIdList with the minimal payload expected by consumers

      // Send entire row objects to consumers (per request)
      this.taskIdList = [...this.filteredTasks];

      // Mark all as completed/selected in our helper array
      this.completedTasks = [...this.filteredTasks];
    } else {
      // Clear all selections
      this.selection.clear();
      this.taskIdList = [];
      this.completedTasks = [];
    }

    this.selectionChanged.emit(this.taskIdList);
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.filteredTasks?.length;
    return numSelected === numRows;

  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.taskId}`;
  }

  toggleRow(row: any) {
    // Toggle selection state
    this.selection.toggle(row);

    // If now selected, add to completedTasks (if not already). If deselected, remove it.
    if (this.selection.isSelected(row)) {
      const exists = this.completedTasks.find(r => r.taskId === row.taskId);
      if (!exists) this.completedTasks.push(row);
    } else {
      this.completedTasks = this.completedTasks.filter(r => r.taskId !== row.taskId);
    }

    // Send the full selected row objects to parent
    this.taskIdList = [...this.selection.selected];
    this.selectionChanged.emit(this.taskIdList);
  }


  phoneNumbercall(data) {
    if (typeof data.leadDetails === 'string') {
      let parsedLead = this.parseLeadDetails(data.leadDetails);
      delete parsedLead.createdDate;
      delete parsedLead.updatedDate;
      
      for (const key in parsedLead) {
        if (typeof parsedLead[key] === 'string' && (parsedLead[key].startsWith('{') || parsedLead[key].startsWith('['))) {
          delete parsedLead[key];
        }
      }
      
      data = { ...data, ...parsedLead };
    }

    if (this.webMobileCallEnable == 1) {

      this.leadActivityService.sendWebToMobileCall(data).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { });

    } else {

      if (this.dialerType == 1) {
        this.leadActivityService.makeCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
              this.dialog.closeAll();
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.dialog.closeAll();
          },
          error => {

          });
      }
      else if (this.dialerType == 2) {
        this.opendialCallsa(data)
        this.callANumber1(data, data.phoneNo)
      }

      else if (this.dialerType == 3) {
        this.loaderService.show();

        let payload = {
          ...data,
          phoneNo: data.phoneNo,
          phone: data.phoneNo
        };

        this.leadActivityService.makeDooctiClickToCall(payload).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 5 || this.dialerType == 9) {
        this.loaderService.show();
        this.leadActivityService.makeTelecmi(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 6) {
        this.loaderService.show();
        this.leadActivityService.clickToCallAcefone(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 7) {
        this.callANumberNew(data)
      }
      else if (this.dialerType == 12) {
        window.dispatchEvent(new CustomEvent('frejun:initiate-call', {
          detail: {
            number: data.phoneNo || data.phoneNumber || '',
            name: data.name || data.leadName || ''
          }
        }));
      }
      else if (this.dialerType == 8) {
        if (window.innerWidth > 768) {

          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            // width: '400px',
            height: 'auto',          // optional
            position: {
              bottom: '2px',        // distance from bottom
              right: '2px'          // distance from right
            },
            disableClose: true,
            data: {
              phone: data.phoneNo
            }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });

        }
        else {
          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            minWidth: '100vw', height: '100vh',
            data: {
              phone: data.phoneNo
            }
          });
          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });
        }
      }

      else if (this.dialerType == 10) {
        this.loaderService.show();
        this.leadActivityService.callForBuzzDieal(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 11) {
        this.loaderService.show();
        this.leadActivityService.calltoElevenlabs(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }

      else {

        this.loaderService.hide();

        let targetLeadId = data.leadId || data.entityId || (data.leadDetails ? data.leadDetails.entityId : null);

        this.addLeadActivity('Phone Call', 0, data.leadDetails, targetLeadId)
      }
    }
  }



  @ViewChild('myFrame') myFrame: ElementRef;
  @ViewChild('headerScroll') headerScroll: ElementRef;
  @ViewChild('bodyScroll') bodyScroll: ElementRef;

  // Sync horizontal scroll of body to header so the scrollbar appears to span full table width
  syncScroll(event: Event) {
    try {
      if (this.headerScroll && this.headerScroll.nativeElement) {
        const target = event.target as HTMLElement;
        this.headerScroll.nativeElement.scrollLeft = target.scrollLeft;
      }
    } catch (err) {
      // swallow - non-critical
    }
  }

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          this.dialerType = data['dialerType'];
          this.webMobileCallEnable = data['webMobileCallEnable'] == undefined ? 0 : data['webMobileCallEnable'];


          let value = localStorage.getItem(Constant.Sup);

          if (value != undefined) {

            if (value == 'salesUser') {


              this.encryptPhone = data['encryptedPhoneNumber'] == undefined ? 0 : data['encryptedPhoneNumber'];

              this.encryptEmail = data['encryptedEmailId'] == undefined ? 0 : data['encryptedPhoneNumber'];

            } else {
              this.encryptPhone = 0;
              this.encryptEmail = 0;
            }

          } else {
            this.encryptPhone = 0;
            this.encryptEmail = 0;
          }


          if (this.dialerType == 7) {
            //   this.initDialer();
          }

          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);


        } else {


        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  opendialCallsa(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }



  callANumber1(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    console.log(number);

    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage({ "data": postData }, 'https://app.doocti.com/');
  }

  callANumberNew(data) {
    const iframeWindow = window.frames['myDialerFrame'] as Window;

    if (!iframeWindow) {
      console.error('Iframe window is not available');
      return;
    }


    let phone = "+" + data.phoneNo.toString();

    const postData = {
      entity_type: "Lead",
      entity_id: data.taskId,
      entity_name: data.name,
      entity_number: phone,
      user_email: data.ownerEmail,
      user_id: data.ownerId,
      event_action: "click2call"
    };


    iframeWindow.postMessage(postData, 'https://client5.rekzyl.com');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://client5.rekzyl.com') return;
      console.log('Response received from iframe:', event.data);
      window.removeEventListener('message', messageHandler);
    };

    window.addEventListener('message', messageHandler);
  }

  closeDialer() {
    this.dialerEnable = false;
  }

  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://app.doocti.com/') {
      return;
    }

    console.log('Received message from iframe:', event.data);
  }


  getDueStatus(date: any): string {
    const today = moment();
    const dueDate = moment(date);

    const diffDays = today.diff(dueDate, 'days');

    if (diffDays === 0) return 'Due today';
    if (diffDays > 0) return `Due ${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    if (diffDays < 0) return `Due in ${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? 's' : ''}`;

    return '';
  }

  isPastOrToday(date: any): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const due = new Date(date);
    due.setHours(0, 0, 0, 0);

    return due <= today; // past or today = red
  }

  isFuture(date: any): boolean {
    return !this.isPastOrToday(date); // future = green
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  addLeadActivity(activityType: string, activityId: number, leadObject: any, leadId: any) {
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.loadTasksNew();
        }
      });
    } else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.loadTasksNew();
        }
      });
    }
  }

  parseLeadDetails(str: string): any {
    if (!str || typeof str !== 'string' || !str.startsWith('Lead(')) {
      return str;
    }

    let content = str.substring(5, str.length - 1);

    let result: any = {};
    let currentKey = '';
    let currentValue = '';
    let inKey = true;
    let braceLevel = 0;
    let bracketLevel = 0;

    for (let i = 0; i < content.length; i++) {
      let char = content[i];

      if (char === '{') braceLevel++;
      if (char === '}') braceLevel--;
      if (char === '[') bracketLevel++;
      if (char === ']') bracketLevel--;

      if (char === '=' && inKey && braceLevel === 0 && bracketLevel === 0) {
        inKey = false;
        continue;
      }

      if (char === ',' && !inKey && braceLevel === 0 && bracketLevel === 0) {
        if (i + 1 < content.length && content[i + 1] === ' ') {
          let val: any = currentValue.trim();
          if (val === 'null') val = null;
          result[currentKey.trim()] = val;
          currentKey = '';
          currentValue = '';
          inKey = true;
          i++;
          continue;
        }
      }

      if (inKey) {
        currentKey += char;
      } else {
        currentValue += char;
      }
    }

    if (currentKey) {
      let val: any = currentValue.trim();
      if (val === 'null') val = null;
      result[currentKey.trim()] = val;
    }

    return result;
  }

}

